export default "__VITE_ASSET__CLF$1m3Y__"